// FileItem.js
import React, { useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { FaEllipsisV, FaChevronLeft  } from 'react-icons/fa';

const ToolBar = ({ currentDirectory, isMobile, navigateBack, handleDrawerOpen, activeTab }) => {
  
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  
  // Auto-scroll to end when path changes
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;
    console.log('scroll')
    // Use rAF to wait for DOM to paint
    const raf = requestAnimationFrame(() => {
      container.scrollTo({
        left: container.scrollWidth,
        behavior: 'smooth'
      });
    });
  
    return () => cancelAnimationFrame(raf); // Clean up on unmount
  }, [currentDirectory]);

  const renderPath = () => {
    return currentDirectory.map((segment, index) => {
      const isEllipsis = segment.name === '...';
      return (
        <span key={index} className="flex items-center">
          {!isEllipsis ? (
            <button
              onClick={() => onPathClick(index)}
              className="text-blue-600 dark:text-blue-300 hover:underline text-sm font-semibold truncate max-w-[100px]"
              title={segment.name}
            >
              {segment.name}
            </button>
          ) : (
            <span className="text-sm text-gray-500 dark:text-gray-400">...</span>
          )}
          {index < currentDirectory.length - 1 && <span className="mx-1 text-gray-400">›</span>}
        </span>
      );
    });
  };

  const onPathClick = (index) => {
    const pathParts = currentDirectory.slice(1, index + 1).map(part => part.name);
    let base = '/browser';

    if (activeTab === 'shared') base = '/browser/shared';
    else if (activeTab === 'favorites') base = '/browser/favorites';

    const newPath = pathParts.length > 0 ? `${base}/${pathParts.join('/')}` : base;
    navigate(newPath);
  };

  return (
    <div>
      <div className="select-none flex justify-between items-center mb-2 bg-white/80 dark:bg-gray-700 backdrop-blur-sm shadow-lg rounded-lg border border-gray-200 dark:border-gray-600">

        {/* Left: Back Button */}
        {currentDirectory.length !== 1 ? (
          <button
            onClick={navigateBack}
            className="h-8 m-1 p-2 rounded-md bg-blue-500 text-white hover:bg-blue-600 transition hover:scale-105 focus:outline-none"
            aria-label="Go back"
          >
            <FaChevronLeft className="w-4 h-4" />
          </button>
        ) : (
          <div className="h-10 w-10"/>
        )}  

        {/* Path Bar */}
        <div
          ref={scrollRef}
          className="pt-1 pb-1 w-full max-w-full overflow-x-auto whitespace-nowrap no-scrollbar px-3 py-2 bg-white/80 dark:bg-gray-700 backdrop-blur-sm shadow-inner rounded-lg border border-gray-200 dark:border-gray-600"
        >
          <div className="flex items-center gap-1 mx-auto w-max">{renderPath()}</div>
        </div>

        {/* Modern dot menu button to open the drawer */}
        {isMobile? ( 
          <button
            onClick={(e) => handleDrawerOpen(e)}
            className="text-2xl focus:outline-none h-10 w-12 flex items-center justify-center"
          >
            <FaEllipsisV className="text-gray-800 dark:text-gray-200"/>
          </button>)
          :
          (<div className="h-10 w-12"/>)
        }

      </div>
    </div>
  );
};

export default ToolBar;